export default __webpack_public_path__ + "static/media/l4-p4.20903f40.svg";